import React from 'react';
import { FontWeight, LabelProps, Switch } from '@easylife365/react';
import { useTranslation } from 'react-i18next';
import { useFilterContext } from '../../../lib/state';

const ClosedTasksSwitch: React.FC = () => {
  const { t } = useTranslation('common');
  const { hideClosedTasks, toggleClosedTasks } = useFilterContext();

  const labelProps: LabelProps = {
    label: t('switches.hideClosedTasks'),
    fontWeight: FontWeight.SemiBold,
  };

  return <Switch label={labelProps} onChange={toggleClosedTasks} checked={hideClosedTasks} />;
};

export default ClosedTasksSwitch;
